import { useGetUser as useGetUserQuery } from '@xhype/card-app-sdk';
import { useAuthStore } from '@package/smart-wallet/store';

export const useGetUserData = () => {
  const { email } = useAuthStore((state) => state);

  /* Queries */
  const {
    data: userInfo,
    isLoading,
    isError,
    error,
    refetch,
  } = useGetUserQuery({
    enabled: !!email,
    email: email ?? '',
  });

  /* Return */
  return {
    isLoading,
    userInfo,
    isError,
    error,
    refetch,
  };
};
